import { useNavigate } from 'react-router-dom';
import { ShoppingCart, X } from 'lucide-react';
import { useOrderComposeStore } from '../../orderComposeStore';
import { useHaptic } from '../../hooks/useHaptic';

/** Полоска «сборка заказа клиента» на каталоге и в корзине. */
export function OrderComposeBanner() {
  const target = useOrderComposeStore((s) => s.target);
  const clearTarget = useOrderComposeStore((s) => s.clearTarget);
  const navigate = useNavigate();
  const haptic = useHaptic();

  if (!target) return null;

  return (
    <div
      className="mx-4 mt-2 mb-1 rounded-xl px-3 py-2.5 flex items-start gap-2 shrink-0"
      style={{ background: 'rgba(99,179,237,0.12)', border: '1px solid rgba(99,179,237,0.35)' }}
    >
      <ShoppingCart size={16} className="shrink-0 mt-0.5" style={{ color: 'var(--cyan)' }} />
      <div className="min-w-0 flex-1">
        <p className="text-[11px] font-bold" style={{ color: 'var(--cyan-bright)' }}>
          Сборка заказа {target.orderNumber}
        </p>
        <p className="text-[10px] leading-snug mt-0.5" style={{ color: 'var(--text-3)' }}>
          Добавляйте в корзину как обычно — затем «В заказ клиента» в корзине.
        </p>
        <button
          type="button"
          className="press text-[10px] font-bold mt-1.5 underline"
          style={{ color: 'var(--cyan)' }}
          onClick={() => {
            haptic.selection();
            navigate('/cart');
          }}
        >
          Перейти в корзину
        </button>
      </div>
      <button
        type="button"
        aria-label="Завершить сборку"
        className="press p-1 rounded-lg shrink-0"
        style={{ background: 'rgba(255,255,255,0.06)' }}
        onClick={() => {
          haptic.selection();
          clearTarget();
        }}
      >
        <X size={16} color="var(--text-3)" />
      </button>
    </div>
  );
}
